import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'poiseReport',
    label: 'POISE Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
